export const CDN_URL = "https://smk-assets.s3.ap-south-1.amazonaws.com/";

export const cdn_link = (path) => `${CDN_URL}${path}`;
